import { CREATE_PRONOUNS_TRANSLATION, GET_PRONOUNS_TASKS } from '@/graphql/queries/assignments';
import { graphqlMutation, graphqlRequest } from './graphqlClient';
import { CreateOrUpdatePronounTranslationInput, MutationCreateOrUpdatePronounTranslationArgs, PronounResponse, TranslationResponse } from '@/graphql/types';

export const fetchPronouns = async (payload: { assignmentId: number }) => {
  const response = await graphqlRequest<{ assignmentId: number }, { pronouns: PronounResponse[] }>(
    GET_PRONOUNS_TASKS,
    payload,
    'network-only',
  );
  return response.pronouns;
};

export const updatePronouns = async (pronouns: CreateOrUpdatePronounTranslationInput) => {
  const response = await graphqlMutation<MutationCreateOrUpdatePronounTranslationArgs, { createOrUpdatePronounTranslation: TranslationResponse[] }>(
    CREATE_PRONOUNS_TRANSLATION,
    {
      pronouns,
    },
  );
  return response.createOrUpdatePronounTranslation;
};
